import React, { useCallback, useEffect, useState } from "react";
import FormInputField from "../common-components/FormInputField";
import { StyledGrid } from "../../pages/incorporation/Incorporation";
import Grid from "@mui/material/Grid2";
import { useFormik } from "formik";
import { StyledTypographyLLc } from "../style/modalStyleLarge";
import UploadFileFieldNew from "../common-components/UploadFileFieldNew";
import { UploadIcon } from "../../assets/Icon/dashboredIcon";
import { PhoneIcon } from "../../assets/Icon/LlcForm";
import SelectInputField from "../common-components/SelectInputField";
import { useSelector } from "react-redux";
import { Typography, Box, CircularProgress } from "@mui/material";
import theme from "../../theme";
import CustomButton from "../common-components/CustomButton";
import DatePickerField from "../common-components/DatePickerField";
import UploadMultipleFile from "../common-components/UploadMultipleFile";
import { businessExpenses, personalIncomeFields } from "../../utils/constants";
import { MultimemberFormSchema } from "../../form-schema";
import TitleBar from "../common-components/TitleBar";
import { StyleDiv } from "../../pages/orderMember/singleMember";
import { StyledButton } from "../style/ititn/DeatilStyle";
import CopyModel from "./CopyModel";
import { useDispatch } from "react-redux";
import { getCountryList } from "../../stores/incorporation";
import {
  deleteUploadedDocument,
  getTaxFilingData,
  getTaxFilingDataById,
  uploadTaxFilingForm,
} from "../../stores/taxfiling";
import { useNavigate, useParams } from "react-router-dom";
import Toast from "../common-components/Toast";
import { setToast } from "../../stores/toast/toastslice";
import BackPageButton from "../common-components/BackPageButton";

const MultimemberForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: ID } = useParams();
  // console.log(ID,"ID");
  const [filePreview, setFilePreview] = useState<string | null>(null);
  const [companyDocPreviews, setCompanyDocPreviews] = useState<string[]>([]);
  const [itinDocPreviews, setItinDocPreviews] = useState<string[]>([]);
  const [einPreviews, setEinPreviews] = useState<string | null>(null);
  const [companyDocuments, setCompanyDocuments] = useState<any[]>([]);
  const [einDocuments, setEinDocuments] = useState<any[]>([]);
  const [itinDocuments, setItinDocuments] = useState<any[]>([]);
  const [isTaxModalOpen, setIsTaxModalOpen] = useState(false);
  const [isSavingDraft, setIsSavingDraft] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isFileDeleted, setIsFileDeleted] = useState(false);
  const { taxfillingOrderList, taxFilingDataReview } = useSelector(
    (state: any) => state.taxfiling,
  );

  // Always treat as array
  const fetchListOrder = taxfillingOrderList?.tax_filing_files_list || [];
  const fetchDocuments = taxFilingDataReview?.documents_by_type || {};
  // console.log(fetchListOrder,"fetchListOrder");
  const taxFilingId =
    taxFilingDataReview?.tax_filing_file?.id ||
    (fetchListOrder?.length ? fetchListOrder[0]?.id : null);
  const taxFilingOrderId =
    taxFilingDataReview?.tax_filing_file?.order_item_id ||
    (fetchListOrder?.length ? fetchListOrder[0]?.order_item_id : null);
  const tsxfillingData =
    taxfillingOrderList?.tax_filing_files_list?.length > 1
      ? taxFilingDataReview?.tax_filing_file?.file_data
      : fetchListOrder[0]?.file_data;
  // console.log(tsxfillingData,"tsxfillingData");
  // Destructure id from fetchListOrder
  // const taxFilingId = fetchListOrder.length > 0 ? fetchListOrder[0]?.id : null;
  const id = ID || taxFilingId;
  const existingData = fetchListOrder.length > 0 ? fetchListOrder[0] : null;
  // const documents = existingData?.documents;
  // console.log(documents,"documents");
  const { countryList } = useSelector((store: any) => store.incorporation);

  useEffect(() => {
    if (countryList.length === 0) {
      dispatch<any>(getCountryList({}));
    }
  }, []);
  const getTaxFilingList = async () => {
    // setLoading(true);
    const payload = {
      offset: 0,
      limit: 10,
    };
    const result = await dispatch<any>(getTaxFilingData(payload));
  };
  useEffect(() => {
    getTaxFilingList();
  }, [id]);

  // Populate form with existing data
  // console.log(taxFilingDataReview?.tax_filing_file?.passport,"passport");
  useEffect(() => {
    if (tsxfillingData) {
      const fileData = tsxfillingData;
      const documents =
        fetchListOrder?.length > 1
          ? taxFilingDataReview?.documents_by_type
          : fetchListOrder[0]?.documents;

      console.log("=== FORM INITIALIZATION DEBUG ===");
      console.log("existingData:", existingData);
      console.log("documents:", documents);
      console.log("documents?.company:", documents?.company);
      console.log("documents?.ein:", documents?.ein);
      console.log("documents?.itin:", documents?.itin);

      console.log(
        fetchListOrder[0]?.passport ?? null,
        "passport_scan value being set in formik",
      );

      // Map API data to form fields
      formik.setValues({
        // Personal Information
        name_surname: fileData.name_surname || "",
        email: fileData.email || "",
        date_of_birth: fileData.date_of_birth || "",
        phone_number: fileData?.phone_number || fileData?.phone || "",
        country_code: fileData.country_code || "",
        country: fileData.country || "",
        us_address: fileData.us_address || "",
        foreign_address: fileData.foreign_address || "",

        // Business Details
        additional_members: fileData.additional_members || "",
        partnership_structure: fileData.partnership_structure || "",
        business_address: fileData.business_address || "",
        nature_of_business: fileData.nature_of_business || "",

        // File uploads - keep as null initially (URLs will be shown separately)
        passport_scan:
          (taxFilingDataReview?.tax_filing_file as any)?.passport ||
          taxFilingDataReview?.documents_by_type?.passport ||
          (taxfillingOrderList?.tax_filing_files_list[0]?.passport ?? ""),
        company_formation_document:
          documents?.company || existingData?.documents?.company || [],
        ein_document: documents?.ein || existingData?.documents?.ein || [],
        itin_document: documents?.itin || existingData?.documents?.itin || [],

        // Business Income
        gross_income: fileData.gross_income || "",
        amount_returns: fileData.amount_returns || "",
        cost_of_goods_sold: fileData.cost_of_goods_sold || "",

        // Business Expenses
        advertising: fileData.advertising || "",
        commissions_fees: fileData.commissions_fees || "",
        contract_labor: fileData.contract_labor || "",
        insurance: fileData.insurance || "",
        interest_bank: fileData.interest_bank || "",
        legal_professional: fileData.legal_professional || "",
        office_expenses: fileData.office_expenses || "",
        pension_profit_sharing: fileData.pension_profit_sharing || "",
        rent_lease_vehicles: fileData.rent_lease_vehicles || "",
        repairs_maintenance: fileData.repairs_maintenance || "",
        supplies_materials: fileData.supplies_materials || "",
        supplies_stationary: fileData.supplies_stationary || "",
        taxes_licenses: fileData.taxes_licenses || "",
        travel_meals: fileData.travel_meals || "",
        utilities: fileData.utilities || "",
        wages: fileData.wages || "",
        other_business: fileData.other_business || "",

        // Personal Income
        personal_gross_income: fileData.personal_gross_income || "",
        interest_income: fileData.interest_income || "",
        tax_exempt_interest: fileData.tax_exempt_interest || "",
        qualified_dividends: fileData.qualified_dividends || "",
        taxable_refunds: fileData.taxable_refunds || "",
        scholarship_fellowship_grants:
          fileData.scholarship_fellowship_grants || "",
        capital_gain_loss: fileData.capital_gain_loss || "",
        other_gains_losses: fileData.other_gains_losses || "",
        ira_distributions: fileData.ira_distributions || "",
        pensions_annuities: fileData.pensions_annuities || "",
        farm_income_loss: fileData.farm_income_loss || "",
        unemployment_compensation: fileData.unemployment_compensation || "",
        other_income: fileData.other_income || "",
      });

      // Handle document previews (if documents exist)
      if (documents?.company && Array.isArray(documents.company)) {
        // Set the actual document objects with IDs
        setCompanyDocuments(documents.company);
        const companyDocUrls = documents.company.map(
          (doc: any) => doc.document_file_url,
        );
        formik.setFieldValue("company_formation_document", companyDocUrls);
        setCompanyDocPreviews(companyDocUrls);
        console.log("Company documents:", companyDocUrls);
      }
      if (documents?.ein && Array.isArray(documents.ein)) {
        // Set the actual document objects with IDs
        setEinDocuments(documents.ein);
        const einDocUrls = documents.ein.map(
          (doc: any) => doc.document_file_url,
        );
        formik.setFieldValue("ein_document", einDocUrls);
        setEinPreviews(einDocUrls);
        console.log("EIN documents:", einDocUrls);
      }
      if (documents?.itin && Array.isArray(documents.itin)) {
        // Set the actual document objects with IDs
        setItinDocuments(documents.itin);
        const itinDocUrls = documents.itin.map(
          (doc: any) => doc.document_file_url,
        );
        formik.setFieldValue("itin_document", itinDocUrls);
        setItinDocPreviews(itinDocUrls);
        console.log("ITIN documents:", itinDocUrls);
      }

      // Handle passport preview if available
      const passportUrl =
        (taxFilingDataReview?.tax_filing_file as any)?.passport ||
        fetchListOrder[0]?.passport;
      if (passportUrl) {
        formik.setFieldValue("passport", passportUrl);
        setFilePreview(passportUrl);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchListOrder, navigate, tsxfillingData]);
  // const getTaxFilingListId = useCallback(async () => {
  //   if (!ID) return;
  //   const payload = {
  //     tax_filing_file_id: ID,
  //   };
  //   await dispatch<any>(getTaxFilingDataById(payload));
  // }, [dispatch, ID]);
  // useEffect(() => {
  //   getTaxFilingListId();
  // }, [getTaxFilingListId]);
  const getTaxFilingListId = useCallback(async () => {
    if (!ID) return;
    const payload = {
      tax_filing_file_id: ID || taxFilingId,
    };
    await dispatch<any>(getTaxFilingDataById(payload)).then(
      async (res: any) => {
        if (res?.payload?.status >= 400) {
          await dispatch<any>(
            setToast({
              message:
                res?.payload?.data?.message ||
                (typeof res?.payload?.data?.message === "string" &&
                  res?.payload?.data?.message) ||
                "Something went wrong!",
              type: "error",
              title: "Error",
            }),
          );
          const timeout = setTimeout(() => {
            navigate("/tools/tax-filing");
          }, 2000);

          return () => clearTimeout(timeout);
        }
        setLoading(false);
      },
    );
  }, [dispatch, id, taxFilingId]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearInterval(timeout);
  }, []);

  useEffect(() => {
    getTaxFilingListId();
  }, [getTaxFilingListId]);
  const handleTaxModalClose = () => {
    setIsTaxModalOpen(false);
  };
  const multiMemberFormhandling = async (
    values: any,
    saveAsDraft: boolean = true,
    isDraft: boolean = false,
  ) => {
    console.log(
      "multiMemberFormhandling called with values:",
      values,
      "saveAsDraft:",
      saveAsDraft,
    );

    if (saveAsDraft) {
      setIsSavingDraft(true);
    } else {
      setLoading(true);
    }
    const formData = new FormData();

    // Create a copy of values to modify for file_data (JSON string)
    const formDataForJson = { ...values };

    // Remove file fields from the JSON payload, as they are sent separately
    delete formDataForJson.passport_copy;
    delete formDataForJson.company_formation_document;
    delete formDataForJson.ein_document;
    delete formDataForJson.itin_document;

    // Append standard fields to FormData (as strings)
    formData.append("tax_filing_file_id", id || taxFilingId);
    formData.append("step", isDraft ? "0" : "1");
    formData.append("save_as_draft", saveAsDraft ? "true" : "false");

    // Append the JSON string of the remaining form data
    formData.append("file_data", JSON.stringify(formDataForJson));

    // Debug: Log file information before processing
    // console.log("=== FILE DEBUGGING ===");
    console.log(
      "values.passport_copy:",
      values.passport_copy,
      "Type:",
      typeof values.passport_copy,
    );
    console.log(
      "values.company_formation_document:",
      values.company_formation_document,
      "Type:",
      typeof values.company_formation_document,
      "IsArray:",
      Array.isArray(values.company_formation_document),
    );
    console.log(
      "values.ein_document:",
      values.ein_document,
      "Type:",
      typeof values.ein_document,
      "IsArray:",
      Array.isArray(values.ein_document),
    );
    console.log(
      "values.itin_document:",
      values.itin_document,
      "Type:",
      typeof values.itin_document,
      "IsArray:",
      Array.isArray(values.itin_document),
    );

    // Append actual file objects to FormData
    // Handle passport (can be File or string)
    if (values.passport_scan instanceof File) {
      console.log("Adding passport file:", values.passport_scan.name);
      formData.append("passport", values.passport_scan);
    } else if (typeof values.passport_scan === "string") {
      console.log("Adding passport string URL:", values.passport_scan);
      formData.append("passport_string", values.passport_scan);
    } else {
      console.log("No valid passport_scan found");
    }

    // Handle company documents (can be array of Files or array of { document_file_url: string })
    if (Array.isArray(values.company_formation_document)) {
      console.log(
        "Processing company_formation_document array with",
        values.company_formation_document.length,
        "items",
      );

      values.company_formation_document.forEach((item: any, index: number) => {
        // If it's a File
        if (item instanceof File) {
          console.log(`Adding company_formation_document (File): ${item.name}`);
          formData.append("company_formation_document", item);
        }
        // If it's an object with document_file_url
        else if (item && typeof item === "object" && item.document_file_url) {
          console.log(
            `Adding company_formation_document (URL string): ${item.document_file_url}`,
          );
          formData.append(
            "company_formation_document_string",
            item.document_file_url,
          );
        }
        // If it's a plain string
        else if (typeof item === "string") {
          console.log(`Adding company_formation_document (string): ${item}`);
          formData.append("company_formation_document_string", item);
        }
      });
    } else {
      console.log("No company_formation_document found or not an array");
    }

    // Handle EIN (single File or array with File/string)
    if (values.ein_document) {
      if (values.ein_document instanceof File) {
        console.log("Adding EIN document (File):", values.ein_document.name);
        formData.append("ein_document", values.ein_document);
      } else if (Array.isArray(values.ein_document)) {
        const firstItem = values.ein_document[0];
        if (firstItem instanceof File) {
          console.log(`Adding EIN document (first File): ${firstItem.name}`);
          formData.append("ein_document", firstItem);
        } else if (
          firstItem &&
          typeof firstItem === "object" &&
          firstItem.document_file_url
        ) {
          console.log(
            `Adding EIN document (URL string): ${firstItem.document_file_url}`,
          );
          formData.append("ein_document_string", firstItem.document_file_url);
        } else if (typeof firstItem === "string") {
          console.log("Adding EIN document (string):", firstItem);
          formData.append("ein_document_string", firstItem);
        }
      } else if (typeof values.ein_document === "string") {
        console.log("Adding EIN document (string):", values.ein_document);
        formData.append("ein_document_string", values.ein_document);
      }
    } else {
      console.log("No EIN document found");
    }

    // Handle ITIN documents (array of Files or array of { document_file_url: string })
    if (Array.isArray(values.itin_document)) {
      console.log(
        "Processing itin_document array with",
        values.itin_document.length,
        "items",
      );

      values.itin_document.forEach((item: any, index: number) => {
        if (item instanceof File) {
          console.log(`Adding ITIN document (File): ${item.name}`);
          formData.append("itin_document", item);
        } else if (item && typeof item === "object" && item.document_file_url) {
          console.log(`Adding ITIN document (URL): ${item.document_file_url}`);
          formData.append("itin_document_string", item.document_file_url);
        } else if (typeof item === "string") {
          console.log(`Adding ITIN document (string): ${item}`);
          formData.append("itin_document_string", item);
        }
      });
    } else {
      console.log("No ITIN documents found or not an array");
    }

    // Debug: Log FormData contents
    console.log("=== FORMDATA CONTENTS ===");
    const formDataEntries = Array.from(formData.entries());
    formDataEntries.forEach((pair) => {
      console.log(
        pair[0] +
          ": " +
          (pair[1] instanceof File ? `File: ${pair[1].name}` : pair[1]),
      );
    });

    console.log("FormData created, about to dispatch API call");
    const result = await dispatch<any>(uploadTaxFilingForm(formData));
    if (saveAsDraft) {
      setIsSavingDraft(false);
    } else {
      setLoading(false);
    }
    if (result?.payload?.status === 1) {
      if (isDraft) {
        dispatch<any>(
          setToast({
            message: "Data is saved as draft!",
            type: "success",
            title: "Success",
            onClose: () => {},
          }),
        );
        return;
      }
      if (fetchListOrder?.length === 1 && isDraft) {
        // Show success message for draft save
        dispatch<any>(
          setToast({
            message: "Data is saved as draft!",
            type: "success",
            title: "Success",
            onClose: () => {},
          }),
        );

        // Don't reload data to prevent form from resetting
        // User can refresh page manually if they want to see updated draft
      }
      if (result?.type?.includes("rejected")) {
        dispatch<any>(
          setToast({
            message: result?.payload?.data?.message || "Something went wrong",
            type: "error",
            title: "Error",
            onClose: () => {},
          }),
        );

        return;
      } else if (fetchListOrder?.length > 1 && isDraft) {
        navigate("/tools/tax-filing/list");
      } else {
        navigate(`/tools/tax-filing/multimember-review/${id}`, {
          state: {
            taxFilingId: id,
            formData: values,
            documents: {
              company: values.company_formation_document,
              ein: values.ein_document,
              itin: values.itin_document,
            },
          },
        });
      }
    }

    // setLoading(false);
  };

  const formik: any = useFormik({
    initialValues: {
      // Personal Information
      name_surname: "",
      email: "",
      date_of_birth: "",
      phone_number: "",
      country: "",
      us_address: "",
      foreign_address: "",

      // Business Details
      additional_members: "",
      partnership_structure: "",
      business_address: "",
      nature_of_business: "",
      country_code: "",
      ein_document: "",

      // File uploads
      passport_scan: "",
      company_formation_document: [],
      itin_document: [],
      passport_scan_string: "",
      ein_document_string: "",
      itin_document_string: "",
      company_formation_document_string: "",

      // Business Income
      gross_income: "",
      amount_returns: "",
      cost_of_goods_sold: "",

      // Business Expenses
      advertising: "",
      commissions_fees: "",
      contract_labor: "",
      insurance: "",
      interest_bank: "",
      legal_professional: "",
      office_expenses: "",
      pension_profit_sharing: "",
      rent_lease_vehicles: "",
      repairs_maintenance: "",
      supplies_materials: "",
      supplies_stationary: "",
      taxes_licenses: "",
      travel_meals: "",
      utilities: "",
      wages: "",
      other_business: "",

      // Personal Income
      personal_gross_income: "",
      interest_income: "",
      tax_exempt_interest: "",
      qualified_dividends: "",
      taxable_refunds: "",
      scholarship_fellowship_grants: "",
      capital_gain_loss: "",
      other_gains_losses: "",
      ira_distributions: "",
      pensions_annuities: "",
      farm_income_loss: "",
      unemployment_compensation: "",
      other_income: "",
    },
    validationSchema: MultimemberFormSchema,
    onSubmit: (values) => {
      multiMemberFormhandling(values, true);
      // navigate("/tools/tax-filing/review");
    },
    validateOnChange: true,
    validateOnBlur: true,
  });
  // console.log(formik.errors,"formik.errors");

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: string,
    setPreview: (url: string | null) => void,
  ) => {
    const file = e.target.files?.[0] || null;
    formik.setFieldValue(fieldName, file);
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setPreview(previewURL);
    } else {
      setPreview("");
    }
  };
  // const handleDeleteUploadedDocument = async (
  //   index: number,
  //   documentType: "company" | "ein" | "itin"
  // ) => {
  //   let documents: any[] = [];
  //   let setDocuments: any;
  //   let setPreviews: any;

  //   // Determine which document array to use based on type
  //   if (documentType === "company") {
  //     documents = companyDocuments;
  //     setDocuments = setCompanyDocuments;
  //     setPreviews = setCompanyDocPreviews;
  //   } else if (documentType === "ein") {
  //     documents = einDocuments;
  //     setDocuments = setEinDocuments;
  //     setPreviews = setEinPreviews;
  //   } else if (documentType === "itin") {
  //     documents = itinDocuments;
  //     setDocuments = setItinDocuments;
  //     setPreviews = setItinDocPreviews;
  //   }

  //   // Get the actual document at this index
  //   const documentToDelete = documents[index];

  //   if (!documentToDelete || !documentToDelete.id) {
  //     console.error("No document found at index", index);
  //     return;
  //   }

  //   console.log("Deleting document with ID:", documentToDelete.id);

  //   // Call API to delete
  //   const result = await dispatch<any>(
  //     deleteUploadedDocument(documentToDelete.id)
  //   );
  //   if (result?.payload?.status === 1) {
  //     // Remove from local state
  //     const updatedDocuments = documents.filter((_, i) => i !== index);
  //     setDocuments(updatedDocuments);

  //     // Update previews
  //     const baseUrl = process.env.REACT_APP_BASE_IMAGE_URL || "";
  //     setPreviews(
  //       updatedDocuments.map((doc: any) => `${baseUrl}${doc.document_file_url}`)
  //     );

  //     dispatch<any>(
  //       setToast({
  //         message: result?.payload?.message || "Document deleted successfully!",
  //         type: "success",
  //         title: "Success",
  //       })
  //     );
  //   }
  // };

  // Additional members options

  const handleDeleteUploadedDocument = async (
    index: number,
    documentType: "company" | "ein" | "itin",
  ) => {
    let documents: any[] = [];
    let setDocuments: any;
    let setPreviews: any;

    // Determine which document array to use based on type
    if (documentType === "company") {
      documents = companyDocuments;
      setDocuments = setCompanyDocuments;
      setPreviews = setCompanyDocPreviews;
    } else if (documentType === "ein") {
      documents = einDocuments;
      setDocuments = setEinDocuments;
      setPreviews = setEinPreviews;
    } else if (documentType === "itin") {
      documents = itinDocuments;
      setDocuments = setItinDocuments;
      setPreviews = setItinDocPreviews;
    }

    // Get the actual document at this index
    const documentToDelete = documents[index];

    // Check if document has an ID (existing document from server)
    if (documentToDelete && documentToDelete.id) {
      console.log("Deleting document with ID:", documentToDelete.id);

      try {
        // Call API to delete
        setIsFileDeleted(true);
        const result = await dispatch<any>(
          deleteUploadedDocument(documentToDelete.id),
        );

        getTaxFilingListId(); // Refresh data after deletion
        if (result?.payload?.status === 1) {
          // Remove from local state
          const updatedDocuments = documents.filter((_, i) => i !== index);
          setDocuments(updatedDocuments);

          // Update previews
          const baseUrl = process.env.REACT_APP_BASE_IMAGE_URL || "";
          setPreviews(
            updatedDocuments.map(
              (doc: any) => `${baseUrl}${doc.document_file_url}`,
            ),
          );

          dispatch<any>(
            setToast({
              message:
                result?.payload?.message || "Document deleted successfully!",
              type: "success",
              title: "Success",
            }),
          );
        }
      } catch (error) {
        console.error("Error deleting document:", error);
        dispatch<any>(
          setToast({
            message: "Failed to delete document. Please try again.",
            type: "error",
            title: "Error",
          }),
        );
      } finally {
        setIsFileDeleted(false);
      }
    } else {
      // Handle local state deletion (for newly uploaded files without ID)
      console.log("Deleting local document at index:", index);

      // Remove from local state
      const updatedDocuments = documents?.filter((_, i) => i !== index);
      setDocuments(updatedDocuments);
      // Update previews
      const baseUrl = process.env.REACT_APP_BASE_IMAGE_URL || "";
      setPreviews(
        updatedDocuments.map(
          (doc: any) => `${baseUrl}${doc.document_file_url || doc}`,
        ),
      );

      // Update formik values
      if (documentType === "company") {
        formik.setFieldValue("company_formation_document", updatedDocuments);
      } else if (documentType === "ein") {
        formik.setFieldValue("ein_document", updatedDocuments);
      } else if (documentType === "itin") {
        formik.setFieldValue("itin_document", updatedDocuments);
      }

      dispatch<any>(
        setToast({
          message: "Document removed successfully!",
          type: "success",
          title: "Success",
        }),
      );
    }
  };

  const additionalMembersOptions = [
    { id: 1, name: "1", value: "1" },
    { id: 2, name: "2", value: "2" },
    { id: 3, name: "3", value: "3" },
    { id: 4, name: "4", value: "4" },
    { id: 5, name: "5", value: "5" },
    { id: 6, name: "6", value: "6" },
  ];
  const handleSaveAsDraft = async () => {
    console.log("handleSaveAsDraft");
    // Validate at least some fields are filled before saving as draft
    if (!formik.values.name_surname && !formik.values.email) {
      //  alert("Please fill in at least Name and Email before saving as draft");
      return;
    }
    try {
      // setIsSavingDraft(true);
      // Call the submission handler with saveAsDraft flag
      await multiMemberFormhandling(formik.values, true, true);
    } catch (error) {
      console.error("Error saving draft:", error);
      //  alert("Failed to save draft. Please try again.");
    } finally {
      // setIsSavingDraft(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      {fetchListOrder?.length > 1 && <BackPageButton title="Orders" />}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <TitleBar
          title="Intake Form for Multi-Member LLC Tax Filling Form"
          isSpan={true}
          spanText="Form V1"
        />
        <StyleDiv>
          <StyledButton
            sx={{ marginRight: "10px" }}
            variant="outlined"
            color="primary"
            onClick={handleSaveAsDraft}
            disabled={isSavingDraft}
          >
            {isSavingDraft ? (
              <CircularProgress size={16} sx={{ color: "#fff" }} />
            ) : (
              "Save As Draft"
            )}
          </StyledButton>
          <StyledButton
            variant="outlined"
            color="primary"
            onClick={() => setIsTaxModalOpen(true)}
          >
            Copy
          </StyledButton>
        </StyleDiv>
      </div>

      <Typography
        variant="body1"
        sx={{
          paddingY: "30px",
          color: "#666",
          wordBreak: "break-word",
          overflowWrap: "break-word",
          maxWidth: "100%",
        }}
      >
        Dear taxpayer, below is our simple tax filing form, if you need help
        with the form and if you don't know your options please don't hesitate
        to book a call here:
        <a
          href="https://calendly.com/theitin/30min?month=2024-11"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#2977CC" }}
        >
          https://calendly.com/theitin/30min?month=2024-11
        </a>
        &nbsp; Please write your name and surname and TAX CONSULTATION on the
        description while booking.
      </Typography>

      <form onSubmit={formik.handleSubmit}>
        <StyledGrid
          container
          spacing={3}
          style={{ width: "100%", minHeight: "auto" }}
        >
          {/* PERSONAL INFORMATION */}

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              PERSONAL INFORMATION
            </StyledTypographyLLc>
            <FormInputField
              placeholder="Enter name and surname"
              formik={formik}
              name="name_surname"
              label="Name and Surname"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              Please upload your passport scan to prevent any mistakes for the
              correct information of your Full Name.
            </StyledTypographyLLc>
            <Box>
              <Typography
                sx={{
                  color: theme.palette.myCustomColor.dark,
                  marginBottom: "10px",
                }}
                variant="h4"
              >
                Passport Scan{" "}
                <span
                  style={{ color: "#666", fontSize: "12px", marginLeft: "3px" }}
                >
                  (optional)
                </span>
              </Typography>

              <UploadFileFieldNew
                title={""}
                icon={<UploadIcon />}
                name="passport_scan"
                formik={formik}
                handleFileChange={(e) =>
                  handleFileChange(e, "passport_scan", setFilePreview)
                }
                setFilePreview={setFilePreview}
                filePreview={filePreview}
                // showInstruction
              />
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter email address"
              formik={formik}
              name="email"
              label="E-Mail"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <DatePickerField
              label="Date of Birth"
              placeholder="Enter date of birth"
              formik={formik}
              name="date_of_birth"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter phone number"
              formik={formik}
              name="phone"
              icon={<PhoneIcon />}
              isPhnNo={true}
              label="Phone"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Include Country Phone Code
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <SelectInputField
              formik={formik}
              placeholder="Select Country"
              label="Country"
              menuData={countryList}
              name="country"
              sendValue
            />
          </Grid>

          {/* BUSINESS DETAILS */}

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              BUSINESS DETAILS
            </StyledTypographyLLc>
            <SelectInputField
              formik={formik}
              placeholder="Nothing selected"
              label="Number of additional members"
              menuData={additionalMembersOptions}
              name="additional_members"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter partnership structure"
              formik={formik}
              name="partnership_structure"
              label=" Please explain below the partnership structure with the names, email, and how much percentage each member will be contracting to get an additional information (optional)"
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              Company Documents
            </StyledTypographyLLc>
            <UploadMultipleFile
              title={""}
              placeholder="Upload a file or drag and drop"
              name="company_formation_document"
              formik={formik}
              icon={<UploadIcon />}
              filePreviews={companyDocPreviews}
              setFilePreviews={setCompanyDocPreviews}
              accept="application/pdf,image/jpeg,image/png"
              disabled={isFileDeleted}
              showMoreButton={true}
              // showInstruction={true}
              showBackground={true}
              modeltitle="Document Instruction"
              documents={companyDocuments}
              onDelete={(index) =>
                handleDeleteUploadedDocument(index, "company")
              }
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter business address"
              formik={formik}
              name="business_address"
              label="Business Address"
              isMulti={true}
              rows={4}
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Include Zip Code
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter nature of business"
              formik={formik}
              name="nature_of_business"
              label="Nature of Business"
              isMulti={true}
              rows={3}
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              we will find the NAICS code of your nature of the business. Please
              describe your business clearly.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>EIN</StyledTypographyLLc>
            {/* <UploadMultipleFile
              title={""}
              placeholder="Upload Documents"
              name="ein_document"
              formik={formik}
              icon={<UploadIcon />}
              filePreviews={einPreviews}
              setFilePreviews={setEinPreviews}
              accept="application/pdf,image/jpeg,image/png"
              disabled={false}
              showMoreButton={true}
              // showInstruction={true}
              showBackground={true}
              modeltitle="Document Instruction"
              // onDelete={(index) => handleDeleteUploadedDocument(index, 'ein')}
            /> */}
            <UploadFileFieldNew
              title={""}
              icon={<UploadIcon />}
              name="ein_document"
              formik={formik}
              handleFileChange={(e) =>
                handleFileChange(e, "ein_document", setEinPreviews)
              }
              setFilePreview={setEinPreviews}
              filePreview={einPreviews}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              ITIN for all members (if you have one){" "}
              <span
                style={{ color: "#666", fontSize: "12px", marginLeft: "3px" }}
              >
                (optional)
              </span>
            </StyledTypographyLLc>
            <UploadMultipleFile
              title={""}
              placeholder="Upload a file or drag and drop"
              name="itin_document"
              formik={formik}
              icon={<UploadIcon />}
              filePreviews={itinDocPreviews}
              setFilePreviews={setItinDocPreviews}
              accept="application/pdf,image/jpeg,image/png"
              disabled={isFileDeleted}
              showMoreButton={true}
              // showInstruction={true}
              showBackground={true}
              modeltitle="Document Instruction"
              documents={itinDocuments}
              onDelete={(index) => handleDeleteUploadedDocument(index, "itin")}
            />
          </Grid>

          {/* BUSINESS INCOME DETAILS */}

          <Grid size={{ xs: 12, md: 12 }}>
            <StyledTypographyLLc isFont={true}>
              BUSINESS INCOME DETAILS
            </StyledTypographyLLc>
            <FormInputField
              placeholder="Enter gross income"
              formik={formik}
              name="gross_income"
              label="Gross Income (USD)"
              type="number"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              You can leave as ZERO if you do not have.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter amount of returns"
              formik={formik}
              name="amount_returns"
              label="Amount of Returns (USD)"
              type="number"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Please provide the amount you did not get the payment for the
              services.
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 12 }}>
            <FormInputField
              placeholder="Enter cost of goods sold"
              formik={formik}
              name="cost_of_goods_sold"
              label="Amount of Cost of Goods Sold (USD)"
              type="number"
            />
            <Typography
              variant="caption"
              sx={{ color: "#666", fontSize: "12px" }}
            >
              Please provide amount you paid for the products your business has
              bought during 2022. You can leave as ZERO if you do not have.
            </Typography>
          </Grid>

          {/* BUSINESS EXPENSE DETAILS */}

          <StyledTypographyLLc isFont={true} sx={{ marginBottom: "-13px" }}>
            BUSINESS EXPENSES DETAILS
          </StyledTypographyLLc>
          {businessExpenses.map((expense, index) => (
            <Grid key={index} size={{ xs: 12, md: 12 }}>
              <FormInputField
                placeholder="Enter amount"
                formik={formik}
                name={expense.name}
                label={expense.label}
                type="number"
              />
              <Typography
                variant="caption"
                sx={{ color: "#666", fontSize: "12px" }}
              >
                {expense.hint}
              </Typography>
            </Grid>
          ))}

          {/* PERSONAL INCOME */}

          <StyledTypographyLLc isFont={true} sx={{ marginBottom: "-13px" }}>
            PERSONAL INCOME DETAILS (Please fill here only if you have any
            additional income besides your US business)
          </StyledTypographyLLc>
          {personalIncomeFields.map((field, index) => (
            <Grid key={index} size={{ xs: 12, md: 12 }}>
              <FormInputField
                placeholder="Enter amount"
                formik={formik}
                name={field.name}
                label={field.label}
                type="number"
              />
              <Typography
                variant="caption"
                sx={{ color: "#666", fontSize: "12px" }}
              >
                {field.hint}
              </Typography>
            </Grid>
          ))}

          {/* Submit Button */}
          <Grid
            size={{ xs: 12, md: 12 }}
            sx={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <CustomButton
              btnTitle="Review"
              type="submit"
              loading={loading || isSavingDraft}
            />
          </Grid>
        </StyledGrid>
      </form>
      <CopyModel
        open={isTaxModalOpen}
        handleClose={() => setIsTaxModalOpen(false)}
        taxfillingOrderList={fetchListOrder}
      />
      {/* <CopyModel open={isTaxModalOpen} handleClose={handleTaxModalClose} taxfillingOrderList={fetchListOrder}/> */}
    </>
  );
};

export default MultimemberForm;
